import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  PotentialAppointmentSlot,
  PotentialAppointmentListModel,
} from "../widget.model";

@Component({
  selector: "step-two",
  templateUrl: "./step-two.component.html",
})
export class StepTwoComponent implements OnInit {
  @Input() potentialAppointmentList: PotentialAppointmentListModel[];
  @Input() stepThree: any;
  @Input() selectedDateFromDatepicker: any;

  @Output() selectedSlot = new EventEmitter();
  @Output() getMorePotentialAppointments = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  getMoreSlots(str: string) {
    this.getMorePotentialAppointments.next(str);
  }

  selectSlot(slot: PotentialAppointmentSlot) {
    this.selectedSlot.next(slot);
  }
}



// WEBPACK FOOTER //
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/app/step-two/step-two.component.ts